import { FormEvent } from "react";
import { Loader2 } from "lucide-react";

export function LoginForgotForm({
  email,
  onEmail,
  submitting,
  error,
  sent,
  onSubmit,
  onBack,
}: {
  email: string;
  onEmail: (value: string) => void;
  submitting: boolean;
  error: string | null;
  sent: boolean;
  onSubmit: (event: FormEvent) => void;
  onBack: () => void;
}) {
  return (
    <form onSubmit={onSubmit} className="login-card" autoComplete="off">
      {error ? <div className="login-error">{error}</div> : null}
      {sent ? <p className="login-step-note">Reset link sent. Check that inbox.</p> : null}
      <label className="sr-only" htmlFor="reset-email">
        Email
      </label>
      <div className="login-field">
        <input
          id="reset-email"
          type="email"
          value={email}
          onChange={(event) => onEmail(event.target.value)}
          className="login-input"
          placeholder="Email"
          autoComplete="email"
          required
        />
      </div>
      <div className="login-actions">
        <button type="submit" disabled={submitting} className="login-button">
          {submitting ? <Loader2 className="h-4 w-4 animate-spin" aria-hidden /> : null}
          Send reset link
        </button>
        <button type="button" className="login-step-back" onClick={onBack}>
          Back
        </button>
      </div>
    </form>
  );
}
